import styled from 'styled-components';

export const SectionHeader = styled.div<{ $hasActions?: boolean }>`
    text-align: left;
    padding: 20px 24px 0px;
    display: ${(props) => (props.$hasActions ? 'flex' : 'block')};
    align-items: ${(props) => (props.$hasActions ? 'flex-start' : 'initial')};
    justify-content: ${(props) => (props.$hasActions ? 'space-between' : 'initial')};
    gap: ${(props) => (props.$hasActions ? '16px' : '0')};

    @media (max-width: 768px) {
        flex-direction: ${(props) => (props.$hasActions ? 'column' : 'row')};
        align-items: ${(props) => (props.$hasActions ? 'stretch' : 'initial')};
    }
`;
